export default __webpack_public_path__ + "static/media/qrcode.f74c2d36.svg";